import { render, staticRenderFns } from "./NPCTalkBlock.vue?vue&type=template&id=1f72665c&scoped=true&"
import script from "./NPCTalkBlock.vue?vue&type=script&lang=js&"
export * from "./NPCTalkBlock.vue?vue&type=script&lang=js&"
import style0 from "./NPCTalkBlock.vue?vue&type=style&index=0&id=1f72665c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f72665c",
  null
  
)

export default component.exports